import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20" aria-labelledby="faq-title">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr] lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-question-line" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 id="faq-title" className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              你想知道的都在这里
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于免费追更、更新频率和移动端阅读的常见疑问，一次性给你讲清楚。还没问到的问题，欢迎随时联系我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              还有疑问？找我们
            </a>
          </div>

          <div className="flex flex-col gap-3 md:gap-4">
            {faqs.map((f, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    open ? 'border-primary-300 bg-background-50 shadow-soft' : 'border-background-200 bg-background-50'
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : i)}
                      className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5 md:py-5"
                      aria-expanded={open}
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${
                            open ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-700'
                          }`}
                        >
                          <i className={open ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                        </span>
                        <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <p className="px-4 pb-5 pl-14 text-sm leading-relaxed text-foreground-600 md:px-5 md:pl-14 md:text-base">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}